var _mask, _rect, _mask2, _rect2, _mask3, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrenage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_257_9156",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 22,
    height: 8,
    rx: 1,
    transform: "rotate(90 16 1)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 22,
    height: 8,
    rx: 1,
    transform: "rotate(90 16 1)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_257_9156)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_257_9156",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.0137,
    y: 4.00002,
    width: 5,
    height: 12,
    rx: 1,
    transform: "rotate(90 18.0137 4.00002)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0137,
    y: 4.00002,
    width: 5,
    height: 12,
    rx: 1,
    transform: "rotate(90 18.0137 4.00002)",
    fill: "white",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_257_9156)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_257_9156",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.9873,
    y: 15,
    width: 5,
    height: 12,
    rx: 1,
    transform: "rotate(90 17.9873 15)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9873,
    y: 15,
    width: 5,
    height: 12,
    rx: 1,
    transform: "rotate(90 17.9873 15)",
    fill: "white",
    strokeWidth: 4,
    mask: "url(#path-3-inside-3_257_9156)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrenage);
export default __webpack_public_path__ + "static/media/Drenage.dc5ec616f84830bfc03cc30c06904c97.svg";
export { ForwardRef as ReactComponent };